/**
 * Email Signup Block Component
 *
 * Handles dynamic padding adjustment for email signup input fields
 * when integrated buttons have variable widths.
 */
class EmailSignupBlock extends HTMLElement {
  constructor() {
    super();
    this.lastButtonWidth = 0;
    this.observer = undefined;

    this.adjustInputPadding = this.adjustInputPadding.bind(this);
  }

  connectedCallback() {
    this.button = this.querySelector('.email-signup__button--integrated');
    this.input = this.querySelector('.email-signup__input');
    this.inputGroup = this.querySelector('.email-signup__input-group');

    const isTextButton = this.button && this.button.classList.contains('email-signup__button--text');

    if (this.button && this.input && this.inputGroup && isTextButton) {
      this.adjustInputPadding();

      this.observer = new ResizeObserver(() => {
        this.adjustInputPadding();
      });
      this.observer.observe(this.button);

      if ('fonts' in document) {
        document.fonts.ready.then(() => {
          this.adjustInputPadding();
        });
      }
    }
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  adjustInputPadding() {
    if (!this.button || !this.inputGroup) return;

    const buttonWidth = this.button.offsetWidth;

    if (buttonWidth !== this.lastButtonWidth) {
      this.lastButtonWidth = buttonWidth;
      this.inputGroup.style.setProperty('--button-actual-width', `${buttonWidth}px`);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const blocks = document.querySelectorAll('email-signup-block');

  blocks.forEach((block) => {
    const enabled = block.dataset.enableFunnel === 'true';
    if (!enabled) return;

    const form = block.querySelector('form');
    if (!form) return;

    const redirectUrl = block.dataset.redirectUrl || '/';
    const input = block.querySelector('input[type="email"]');
    if (!input) return;

    form.addEventListener('submit', (event) => {
      if (form.dataset.submitting) return;
      form.dataset.submitting = 'true';

      event.preventDefault();

      const email = input.value.trim();
      if (!email || !email.includes('@')) {
        input.focus();
        form.dataset.submitting = '';
        return;
      }

      try {
        localStorage.setItem('youknow_email', email);
      } catch (err) {
        console.warn('LocalStorage unavailable:', err);
      }

      form.submit();

      setTimeout(() => {
        window.location.href = redirectUrl;
      }, 200);
    });
  });
});

if (!customElements.get('email-signup-block')) {
  customElements.define('email-signup-block', EmailSignupBlock);
}
